/**
 * Utility functions for report publishing logic
 */

// Regex pattern to match any TREC special type (TREC, TREC_7_6, TREC_8_7, etc.)
const TREC_PATTERN = /^TREC(_\d+_\d+)?$/i;

/**
 * Check if a template has a TREC special type
 */
export function isTrecTemplate(template) {
  const specialType = template?.attributes?.special_type;
  return specialType && TREC_PATTERN.test(specialType);
}

/**
 * Check if a template is AI compatible (no special type or TREC type)
 */
export function isAiCompatibleTemplate(template) {
  const specialType = template?.attributes?.special_type;
  return !specialType || TREC_PATTERN.test(specialType);
}

/**
 * Check if a report can be published
 */
export function reportCanPublish(attributes) {
  if (!attributes) return false
  const { complete, special_type: specialType } = attributes
  return complete || (specialType && !TREC_PATTERN.test(specialType))
}

/**
 * Determines if publishing should be blocked based on company settings and report completion.
 * @param {Array} reports - Array of report objects (can be { data: { attributes } } or { attributes })
 * @param {boolean} companyRequiresCompletion - Whether company requires completion to publish
 * @returns {boolean} - true if publishing should be blocked
 */
export function shouldBlockPublishing(reports, companyRequiresCompletion) {
  if (!companyRequiresCompletion) {
    return false
  }

  return !reports.every((report) => {
    // Handle both { data: { attributes } } and { attributes } formats
    const attributes = report.data?.attributes || report.attributes
    return reportCanPublish(attributes)
  })
}

